export default __webpack_public_path__ + "static/media/frog_R2_C3.c84fdb24.png";